import React from 'react';

import './LoginPopup.scss';

export default function LoginPopup(props) {
  return (
    <section className="loginPopup">
      <div className="loginPopup_content">
        <div className="loginPopup_close_button">
          <span onClick={() => props.showLoginPopup(false)}>
            Sluiten <span>&times;</span>
          </span>
        </div>

        <p className="loginPopup_title">{props.title}.</p>

        <a href={props.loginUrl}>Inloggen</a>
        <a href={props.signupUrl}>Registreren</a>
      </div>
    </section>
  );
}
